import { SchoolContentOptions } from "../pages/school/main/School";

export const ROUTE_SCHOOL_ID = ":schoolId";

export function routeSchool(schoolId: string, tab?: SchoolContentOptions): string {
    return `/school/${schoolId}${tab ? `#${tab}` : ""}`;
}

export function routeSchoolEdit(schoolId: string): string {
    return `/school/${schoolId}/edit`;
}

export function routeSchoolImage(schoolId: string): string {
    return `/school/${schoolId}/image`;
}

export function routeSchoolNew(): string {
    return "/school/new";
}

// export function routeSchoolUserNew(schoolId: string): string {
//     return `/school/${schoolId}/user/new`;
// }

// export function routeSchoolImagesAdd(schoolId: string): string {
//     return `/school/${schoolId}/images/add`;
// }
